import localize from "helpers/localize";
import { apMask } from "helpers/maskHelper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import EditForm from "../../../../../Components/Forms/Builder/EditForm";
import InputField from "../../../../../Components/Forms/Fields/Input";
import Validations from "../../../../../Components/Forms/Validations";

class BannedCashregisterForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    fieldErrors: PropTypes.object,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired
  };

  render() {
    const {
      handleInputChange,
      fieldErrors,
      isViewPage,
      enabledFields
    } = this.props;

    return (
      <EditForm {...this.props}>
        <div className="col-12">
          <Field
            name="apn"
            label={localize("cashregisters", "AP szám")}
            fieldError={fieldErrors.number}
            onChange={() => handleInputChange("apn")}
            isRequired={true}
            validate={[Validations.required]}
            component={InputField}
            type="text"
            placeholder={localize("cashregisters", "AP szám")}
            isViewPage={isViewPage}
            readOnly={
              enabledFields
                ? enabledFields.indexOf("apn") !== -1
                  ? false
                  : true
                : false
            }
            {...apMask}
          />
        </div>
      </EditForm>
    );
  }
}

const UsersReduxForm = reduxForm({
  form: "bannedCashregisters",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  updateUnregisteredFields: true,
  destroyOnUnmount: false
})(BannedCashregisterForm);

export default connect(
  state => ({
    initialValues: state.bannedCashregisters.viewData
  }),
  null
)(UsersReduxForm);
